/*
 * nav/constants.js
 *
 * Ensure each action has a corresponding type here.
 * To avoid reducer conflicts, these should be prefixed
 * with the parent directory.
 */

export const CHECK_CRBS_CONFIGURED_START = "base/CHECK_CRBS_CONFIGURED_START";
export const CHECK_CRBS_CONFIGURED_SUCCESS =
  "base/CHECK_CRBS_CONFIGURED_SUCCESS";
export const CHECK_CRBS_CONFIGURED_FAILED = "base/CHECK_CRBS_CONFIGURED_FAILED";

export const CHECK_AUTH = "base/CHECK_AUTH";
export const CHECK_AUTH_FAILED = "base/CHECK_AUTH_FAILED";

export const NOTIFICATION_CREATE = "base/NOTIFICATION_CREATE";
export const NOTIFICATION_REMOVE = "base/NOTIFICATION_REMOVE";
export const NOTIFICATION_CLEAR = "base/NOTIFICATION_CLEAR";
